module.exports = __webpack_public_path__ + "static/media/umrahsolution.ea78108e.png";